import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { ApolloProvider } from '@apollo/client';
import { getAzureApolloClient } from './helpers/ApolloHelper';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'element-theme-default';

const client = getAzureApolloClient();
ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
